module.exports = __webpack_public_path__ + "static/img/hzhb_za.dc9db80.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/hzhb_za.png
// module id = /tqM
// module chunks = 0